import PresenceGroup from './group';
import PresenceGroupV2 from './group-v2';
import { PRESENCE_APP_DEF_ID } from './constants';
import { Scope, Status, ActivityStatus } from './domain';
export { Scope, Status, ActivityStatus };
export { DeviceType } from '@wix/ambassador-presence-v2-presence/types';
export default class Presence {
    constructor({ duplexer, getSignedInstance, httpClient }) {
        this.duplexer = duplexer;
        this.getSignedInstance = getSignedInstance ?? (() => '');
        this.httpClient = httpClient;
    }
    group(scope, opts) {
        verifyScope(scope);
        const getPresenceConnection = () => this.getConnection();
        return new PresenceGroup({
            getPresenceConnection,
            scope,
            getSignedInstance: this.getSignedInstance,
            initialState: opts?.initialState,
            keepAliveInterval: opts?.keepAliveInterval,
            onIdle: opts?.onIdle,
            onActive: opts?.onActive,
            isIdleMs: opts?.isIdleMs,
        });
    }
    groupV2(scope, opts) {
        if (!this.httpClient) {
            throw new Error('Cannot init presence GroupV2 without HttpClient instance');
        }
        const getPresenceConnection = () => this.getConnection();
        return new PresenceGroupV2({
            getPresenceConnection,
            scope,
            httpClient: this.httpClient,
            getInitialState: opts?.getInitialState,
            keepAliveInterval: opts?.keepAliveInterval,
            onIdle: opts?.onIdle,
            onActive: opts?.onActive,
            isIdleMs: opts?.isIdleMs,
        });
    }
    getConnection() {
        return this.duplexer.connect({ appDefId: PRESENCE_APP_DEF_ID });
    }
}
function verifyScope(scope) {
    if (!Object.values(Scope).includes(scope)) {
        throw new Error(`scope ${scope} is invalid!`);
    }
}
//# sourceMappingURL=index.js.map